import { useEffect, useState } from "react";

// Mobile-only swipe indicator for horizontal carousels. Layout-agnostic: it tracks the
// scroll position as a ratio and maps it onto `count` dots, so it works for single-card
// carousels and multi-row strips alike. Tapping a dot scrolls to that position; snap
// alignment then settles it on the nearest card. Hidden at md+ (desktop uses a grid).
export const CarouselDots = ({ scrollerRef, count, testid = "carousel", marginClass = "mt-6" }) => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const el = scrollerRef.current;
    if (!el || count <= 1) return;
    const update = () => {
      const max = el.scrollWidth - el.clientWidth;
      const ratio = max > 0 ? el.scrollLeft / max : 0;
      setActive(Math.max(0, Math.min(count - 1, Math.round(ratio * (count - 1)))));
    };
    update();
    el.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      el.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [scrollerRef, count]);

  const go = (i) => {
    const el = scrollerRef.current;
    if (!el || count <= 1) return;
    const max = el.scrollWidth - el.clientWidth;
    el.scrollTo({ left: (i / (count - 1)) * max, behavior: "smooth" });
  };

  if (!count || count <= 1) return null;

  return (
    <div
      data-testid={`${testid}-dots`}
      aria-label="Swipe through cards"
      className={`flex md:hidden items-center justify-center gap-2 ${marginClass}`}
    >
      {Array.from({ length: count }).map((_, i) => (
        <button
          key={i}
          type="button"
          data-testid={`${testid}-dot-${i}`}
          aria-label={`Go to item ${i + 1}`}
          aria-current={i === active ? "true" : undefined}
          onClick={() => go(i)}
          className={`h-2 rounded-full transition-all duration-300 ${
            i === active ? "w-6 bg-terracotta" : "w-2 bg-navy/25 hover:bg-navy/50"
          }`}
        />
      ))}
    </div>
  );
};
